import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Table,
  OverlayTrigger,
  Popover,
  Modal,
} from "react-bootstrap";
import { RotatingLines } from "react-loader-spinner";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import url from "../../../configs/config";
import Card from "../../../components/Card";
import AlertNotificationSimple from "../../../components/alert/alert-notification-simple";
import { IoEyeOutline } from "react-icons/io5";
import { BsInbox } from "react-icons/bs";
import Select from "react-select";
import FadeLoaderComponent from "../../../components/loader-component";
import SearchInput from "../../../components/search-input";
import PaginationComponent from "../../../components/pagination/pagination-component";
import * as SettingSelector from "../../../store/setting/selectors";
import { useSelector } from "react-redux";
import { roleTypes } from "../../../data/roleType";
import EditableDateField from "../../../components/input/editable-date-picker-field";

const EditableField = ({
  id,
  type,
  disabled = false,
  value,
  field,
  onSave,
  isSuccess,
  isFail,
  setFailStatus,
}) => {
  const [editedValue, setEditedValue] = useState(value);
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async (newValue) => {
    if (value !== newValue) {
      setIsLoading(true);
      try {
        if (
          (field === "date" && newValue !== "") ||
          (field === "shipTo" && newValue.length >= 2)
        ) {
          await onSave(id, field, newValue);
        }
      } catch (error) {
        setFailStatus({
          field,
          id: id,
        });
        setTimeout(() => {
          setFailStatus({});
        }, 1000);
        setEditedValue(value);
      } finally {
        // setFailStatus({
        //   field,
        //   id: id,
        // });
        setTimeout(() => {
          setFailStatus({});
        }, 1000);
        setTimeout(() => setIsLoading(false), 200);
      }
    }
  };

  const handleBlur = () => {
    if (field !== "date") {
      handleSave(editedValue);
    }
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setEditedValue(newValue);
    if (field === "date") {
      handleSave(newValue);
    }
  };

  useEffect(() => {
    setEditedValue(value);
  }, [value]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.target.blur();
    }
  };

  return (
    <div
      style={{ position: "relative", display: "inline-block", width: "100%" }}
    >
      <Form.Control
        type={type}
        value={editedValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        className="form-control form-control-sm"
        style={{
          border: "1px solid #dee2e6",
          borderRadius: "4px",
          padding: "4px 8px",
          width: "100%",
          backgroundColor: disabled && "white",
          borderColor:
            isSuccess.id === id && isSuccess.field === field
              ? "green"
              : isFail.id === id && isFail.field === field && "red", // Dynamic border color
          boxShadow:
            isSuccess.id === id && isSuccess.field === field
              ? "0 0 5px green"
              : isFail.id === id && isFail.field === field && "0 0 5px red",
        }}
        disabled={isLoading || disabled}
      />
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "10px",
            transform: "translateY(-50%)",
            pointerEvents: "none",
          }}
        >
          <RotatingLines
            strokeWidth="5"
            animationDuration="0.75"
            width="20"
            strokeColor="#b2b4b9"
            color="#b2b4b9"
            visible={true}
          />
        </div>
      )}
    </div>
  );
};

const EditableFieldSelectStatus = ({
  id,
  disabled,
  value,
  field,
  onSave,
  optionsStatus,
  isSuccess,
  isFail,
  setFailStatus,
  orderProducts = [],
  item,
}) => {
  const [editedValue, setEditedValue] = useState(value);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingValue, setPendingValue] = useState(null);
  const [showSerialModal, setShowSerialModal] = useState(false);
  const [serialItems, setSerialItems] = useState([]);
  const token = localStorage.getItem("coyote-token");
  const navigate = useNavigate();
  const handleChange = async (selectedOption) => {
    const newValue = selectedOption ? selectedOption.value : null;
    if (newValue === "Partially Received" && value !== newValue) {
      navigate(`/dashboard/app/purchase-order-receive-review/${id}`, {
        state: {
          orderData: item,
          selectedStatus: newValue,
          fromStatusChange: true,
        },
      });
      return;
    }

    if (newValue === "Received in Full" && value !== newValue) {
      navigate(`/dashboard/app/purchase-order-receive-review/${id}`, {
        state: {
          orderData: item,
          selectedStatus: newValue,
          fromStatusChange: true,
        },
      });
      return;
    }

    await processStatusChange(newValue);
  };

  const processStatusChange = async (newValue) => {
    setEditedValue(newValue);

    if (value !== newValue && newValue !== null && newValue !== "") {
      setIsLoading(true);
      try {
        await onSave(id, field, newValue);
      } catch (error) {
        setFailStatus({
          field,
          id: id,
        });
        setTimeout(() => {
          setFailStatus({});
        }, 1000);
        setEditedValue(value);
      } finally {
        setTimeout(() => {
          setFailStatus({});
        }, 1000);
        setTimeout(() => setIsLoading(false), 200);
      }
    } else {
      setEditedValue(value);
    }
  };

  const handleConfirmReceived = async () => {
    setShowConfirmModal(false);
    await processStatusChange(pendingValue);
    setPendingValue(null);
  };

  const handleSerialSubmit = async (serialNumbers) => {
    setShowSerialModal(false);
    setEditedValue(pendingValue);
    if (pendingValue && value !== pendingValue) {
      setIsLoading(true);
      try {
        const config = { headers: { Authorization: token } };
        await axios.put(
          `${url.backendURL}order/${id}/field`,
          { status: pendingValue, serialNumbers },
          config
        );
        await onSave(id, "status", pendingValue);
      } catch (error) {
        setFailStatus({ field, id });
        setTimeout(() => setFailStatus({}), 1000);
        setEditedValue(value);
      } finally {
        setTimeout(() => setIsLoading(false), 200);
      }
    }
    setPendingValue(null);
  };

  const handleSerialCancel = () => {
    setShowSerialModal(false);
    setPendingValue(null);
    setSerialItems([]);
    setEditedValue(value);
  };

  const handleCancelReceived = () => {
    setShowConfirmModal(false);
    setPendingValue(null);
    setEditedValue(value); 
  };

  useEffect(() => {
    setEditedValue(value);
  }, [value]);
  return (
    <div
      style={{ position: "relative", display: "inline-block", width: "100%" }}
    >
      <Select
        closeMenuOnScroll={(e) => {
          try {
            const target = e.target;

            if (
              !target ||
              !target.nodeType ||
              typeof target.closest !== "function"
            ) {
              return true;
            }

            const isMenuScroll =
              target.closest('[class*="MenuList"]') ||
              target.closest('[class*="menu"]');

            return !isMenuScroll;
          } catch (error) {
            return true;
          }
        }}
        name="status"
        value={optionsStatus?.find((option) => option.value === editedValue)}
        onChange={handleChange}
        options={optionsStatus.filter(
          (option) =>
            option.value !== "Received in Full" &&
            option.value !== "Partially Received",
        )}
        placeholder="Select Status"
        menuPortalTarget={document.body}
        menuPosition="fixed"
        menuPlacement="auto"
        styles={{
          container: (provided) => ({
            ...provided,
            width: "200px",
          }),
          control: (provided) => ({
            ...provided,
            color: "#5e667b",
            borderColor:
              isSuccess?.id === id && isSuccess?.field === "status"
                ? "green"
                : isFail?.id === id && isFail?.field === "status" && "red",
            boxShadow:
              isSuccess?.id === id && isSuccess?.field === "status"
                ? "0 0 5px green"
                : isFail?.id === id &&
                  isFail?.field === "status" &&
                  "0 0 5px red",
            backgroundColor: disabled && "white",
          }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
              ? "#007bff"
              : state.isFocused
                ? "#e6f7ff"
                : "#fff",
            color: "#333",
            fontSize: "0.8rem",
          }),
          menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999,
          }),
          menu: (provided) => ({
            ...provided,
            zIndex: 9999,
          }),
        }}
        isDisabled={isLoading || disabled}
      />

      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
            transform: "translateY(-50%)",
            pointerEvents: "none",
          }}
        >
          <RotatingLines
            strokeWidth="5"
            animationDuration="0.75"
            width="20"
            strokeColor="#b2b4b9"
            color="#b2b4b9"
            visible={true}
          />
        </div>
      )}

      {/* Confirmation Modal */}
      <Modal
        show={showConfirmModal}
        onHide={handleCancelReceived}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header className="custom-modal-header d-flex  relative">
          <Modal.Title>Mark as Received?</Modal.Title>
          <button
            type="button"
            className="btn-close-svg"
            style={{ position: "absolute", right: "1rem" }}
            onClick={handleCancelReceived}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </Modal.Header>

        <Modal.Body>
          <p>
            Are you sure all items in this order have been received? This action
            will mark the entire order as received
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={handleConfirmReceived} variant="btn btn-primary">
            <i className="fas fa-check me-2" style={{ fontSize: "0.8rem" }}></i>
            Submit
          </Button>
          <Button variant="btn btn-danger" onClick={handleCancelReceived}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const OrderRequestList = () => {
  const alertRef = useRef(null);
  const [successStatus, setSuccessStatus] = useState({});
  const [failStatus, setFailStatus] = useState({});
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteIsSubmit, setDeleteIsSubmit] = useState(true);
  const [dataLoader, setDataLoader] = useState(true);
  const [selectedData, setSelectedData] = useState();
  const [decodedToken, setDecodedToken] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [totalEntries, setTotalEntries] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [highlightedOrderId, setHighlightedOrderId] = useState(null);
  const apiCallInProgress = useRef(false);
  const initialLoadComplete = useRef(false);
  const abortControllerRef = useRef(null);

  const token = localStorage.getItem("coyote-token");
  const [alert, setAlert] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });
  const permissions = useSelector(SettingSelector.set_permissions);
  const orderHasViewPermission = permissions?.purchase_order?.view === true;
  const orderHasUpdatePermission = permissions?.purchase_order?.update === true;
  const orderHasDeletePermission = permissions?.purchase_order?.delete === true;
  const orderHasCreatePermission = permissions?.purchase_order?.create === true;
  const orderHasStatusPermission = permissions?.purchase_order?.status === true;

  const [showPopover, setShowPopover] = useState(null);
  const [showPopoverSerialModal, setShowPopoverSerialModal] = useState(false);
  const [popoverSerialItems, setPopoverSerialItems] = useState([]);
  const [popoverPendingItemId, setPopoverPendingItemId] = useState(null);

  const togglePopover = (idx) => {
    if (showPopover === idx) {
      setShowPopover(null);
    } else {
      setShowPopover(idx);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (showPopover !== null) {
        setShowPopover(null);
      }
    };

    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [showPopover]);

  const handleReceiveAction = async (e, item, actionValue) => {
    e.preventDefault();
    setShowPopover(null);

    if (actionValue === "Partially Received") {
      navigate(`/dashboard/app/purchase-order-receive-review/${item.id}`, {
        state: {
          orderData: item,
          selectedStatus: actionValue,
          fromStatusChange: true,
        },
      });
      return;
    }

    if (actionValue === "Received in Full") {
      navigate(`/dashboard/app/purchase-order-receive-review/${item.id}`, {
        state: {
          orderData: item,
          selectedStatus: actionValue,
          fromStatusChange: true,
        },
      });
      return;
    }
  };

  useEffect(() => {
    if (token && typeof token === "string") {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded?.user);
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, [token]);

  const getOrders = async (offset = 0, limit = 10) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();

    if (apiCallInProgress.current) return;
    apiCallInProgress.current = true;

    if (!token) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${
          decodedToken?.roles?.some(
            (role) => role.role_type === roleTypes.SUPER_ADMIN,
          )
            ? "admin"
            : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        },
      );
      setDataLoader(false);
      return;
    } else {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
        params: {
          offset,
          limit,
          search:
            searchQuery.trim().length >= 2
              ? searchQuery.trim()
              : searchQuery.trim().length < 1
                ? null
                : null,
        },
        signal: abortControllerRef.current.signal,
      };

      try {
        const response = await axios.get(`${url.backendURL}order/`, config);

        if (!abortControllerRef.current.signal.aborted) {
          setOrders(response.data.response.data);
          setTotalEntries(response.data.response.orders_count);
          setDataLoader(false);
        }
      } catch (err) {
        if (axios.isCancel(err) || err.name === "AbortError") {
          return;
        }

        if (alertRef?.current) {
          alertRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
        handleError(err, "orders");
        setDataLoader(false);
      } finally {
        apiCallInProgress.current = false;
        initialLoadComplete.current = true;
      }
    }
  };

  const handleError = (err, alertFor) => {
    const { response } = err;
    if (
      response?.data?.error === "jwt expired" ||
      response?.data?.error === "Unauthorized. User not found"
    ) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${
          decodedToken?.roles?.some(
            (role) => role.role_type === roleTypes.SUPER_ADMIN,
          )
            ? "admin"
            : "user"
        }/auth/sign-in`,
        {
          state: { status: "expired" },
        },
      );
    } else {
      setAlert({
        message: response ? response.data.message : "An error occurred",
        type: "danger",
        show: true,
        alertFor,
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
    }
  };

  useEffect(() => {
    if (location.state?.highlightedOrderId) {
      setHighlightedOrderId(location.state.highlightedOrderId);

      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }

      setAlert({
        message: "Order created successfully",
        type: "success",
        show: true,
        alertFor: "orders",
      });

      navigate(location.pathname, { replace: true, state: {} });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);

      setTimeout(() => {
        setHighlightedOrderId(null);
      }, 5000);
    }
  }, [location.state, navigate]);

  useEffect(() => {
    if (!decodedToken) return;
    if (!initialLoadComplete.current) {
      getOrders((currentPage - 1) * entriesPerPage, entriesPerPage);
    } else if (!apiCallInProgress.current) {
      getOrders((currentPage - 1) * entriesPerPage, entriesPerPage);
    }
  }, [currentPage, entriesPerPage, decodedToken]);

  useEffect(() => {
    if (!initialLoadComplete.current) return;

    const debounceTimer = setTimeout(async () => {
      if (searchQuery.trim().length >= 2 || searchQuery.trim().length < 1) {
        setLoading(true);
        setCurrentPage(1);
        await getOrders(0, entriesPerPage);

        setLoading(false);
      }
    }, 300);

    return () => {
      clearTimeout(debounceTimer);
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [searchQuery]);

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const handlePageChange = (pageNumber) => {
    if (totalEntries === 0) return;
    setCurrentPage(pageNumber);
  };

  const handleEntriesPerPageChange = (e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const handleSaveField = async (id, field, value) => {
    if (!token) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${
          decodedToken?.roles?.some(
            (role) => role.role_type === roleTypes.SUPER_ADMIN,
          )
            ? "admin"
            : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        },
      );
      return;
    }

    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const response = await axios.put(
        `${url.backendURL}order/${id}/field`,
        { [field]: value },
        config,
      );

      field = field === "shipTo" ? "ship_to" : field;
      const updatedOrders = orders.map((order) => {
        if (order.id === id) {
          return { ...order, [field]: value };
        }
        return order;
      });

      setOrders(updatedOrders);
      setSuccessStatus({
        id: id,
        field: field === "ship_to" ? "shipTo" : field,
      });
      if (field === "status") {
        if (alertRef.current) {
          alertRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
        setAlert({
          message: response
            ? response.data.message
            : `Order status updated to ${value} successfully`,
          type: "success",
          show: true,
          alertFor: "orders",
        });
        setTimeout(() => {
          setAlert({ show: false, alertFor: "", message: "", type: "" });
        }, 4000);
      }
      await getOrders((currentPage - 1) * entriesPerPage, entriesPerPage);

      setTimeout(() => {
        setSuccessStatus({});
      }, 1000);
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
    } catch (err) {
      if (alertRef?.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setFailStatus({
        field,
        id,
      });
      setTimeout(() => {
        setFailStatus({});
      }, 1000);
      handleError(err, "orders");
    }
  };

  const [optionsStatus, setOptionsStatus] = useState([
    { id: 1, label: "Received in Full", value: "Received in Full" },
    { id: 2, label: "Payment Pending", value: "Payment Pending" },
    { id: 3, label: "Payment Confirmed", value: "Payment Confirmed" },
    { id: 4, label: "Order Processing", value: "Order Processing" },
    { id: 5, label: "Ready for Dispatch", value: "Ready for Dispatch" },
    { id: 6, label: "Dispatched", value: "Dispatched" },
    { id: 7, label: "In Transit", value: "In Transit" },
    { id: 8, label: "Out for Delivery", value: "Out for Delivery" },
    { id: 9, label: "Delivered", value: "Delivered" },
    { id: 10, label: "Partially Received", value: "Partially Received" },
    { id: 11, label: "On Hold", value: "On Hold" },
    { id: 12, label: "Backordered", value: "Backordered" },
    { id: 13, label: "Cancelled", value: "Cancelled" },
    { id: 14, label: "Returned", value: "Returned" },
    { id: 15, label: "Refund Issued", value: "Refund Issued" },
  ]);
  const getLocalDate = (date) => {
    const now = new Date(date);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

     useEffect(() => {
      function toggleStickyNames() {
        const isWideScreen = window.innerWidth > 650;
  
        const stickyHeadName = document.querySelector(".sticky-head-name");
        const stickyDataNames = document.querySelectorAll(".sticky-data-names");
  
        if (isWideScreen) {
          stickyHeadName?.classList.add("sticky-action-head-buttons");
          stickyDataNames.forEach((data) =>
            data.classList.add("sticky-action-buttons"),
          );
        } else {
          stickyHeadName?.classList.remove("sticky-action-head-buttons");
          stickyDataNames.forEach((data) =>
            data.classList.remove("sticky-action-buttons"),
          );
        }
      }
      toggleStickyNames();
      window.addEventListener("resize", toggleStickyNames);
      return () => window.removeEventListener("resize", toggleStickyNames);
    });

  return (
    <>
     <style>
        {`
          .table-user .sticky-action-buttons {
            background-color: #ffffff !important;
            z-index: 2;
          }
          .table-user .tr-user:hover .sticky-action-buttons {
            background-color: #f5f6fa !important;
          }
          .table-user .sticky-action-head-buttons {
            background: #e2e4e9 !important;
          }
          .table-user .sticky-action-head-buttons,
          .table-user .sticky-action-buttons {
            left: 0;
            z-index: 11;
            position: absolute;
            width: 260px;
            height: inherit;
            display: flex;
            align-items: center;
            padding-left: 15px;
            border-bottom: 1px solid #ebedef !important;
          }
          .table-user .sticky-action-buttons {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .table-user .th-user:nth-child(2),
          .table .td-user:nth-child(2) {
            padding-left: 275px !important;
          }
           @media (max-width: 650px) {
            .table-user .sticky-action-head-buttons,
            .table-user .sticky-action-buttons {
               position: static !important;
               width: auto !important;
               white-space: normal !important;
            }
            .table-user .th-user:nth-child(2),
            .table .td-user:nth-child(2) {
              padding-left: 0.75rem !important;
            }
          }
        `}
      </style>

      <div>
        {/* <div className="bd-example">
                                    <div className="d-flex justify-content-between flex-wrap pl-0 pt-0">
                                      <Modal
                                        show={productsViewModel}
                                        onHide={handleCloseProductsView}
                                        backdrop="true"
                                        keyboard={true}
                                        size="xl"
                                        style={{ maxHeight: "100vh" }}
                                      >
                                        <Modal.Header closeButton>
                                          <Modal.Title>Order Status</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body
                                          style={{
                                            maxHeight: "calc(100vh - 200px)",
                                            overflowY: "auto",
                                            padding: "1rem",
                                          }}
                                        >
                          
                                          <div
                                            className=""
                                            style={{
                                              maxHeight: "400px",
                                              overflowY: "auto",
                                              overflowX: "auto",
                                            }}
                                          >
                                      
                                          </div>
                                        </Modal.Body>
        
                                        <Modal.Footer className="d-flex justify-content-end">
                                          <Button
                                            variant="primary"
                                            disabled={selectedProducts.length === 0}
                                            onClick={() => {
                                              const newItems = selectedProducts
                                                .filter(
                                                  (selected) =>
                                                    !selectedProductListIds.some(
                                                      (item) =>
                                                        item.productId ===
                                                        selected.productId
                                                    )
                                                )
                                                .map((item) => ({
                                                  ...item,
                                                  jobId: item.jobId || jobId || null,
                                                  itemStatus: "add",
                                                }));
        
                                              // Update the separate state
                                              setSelectedAddedProducts((prev) => [
                                                ...prev,
                                                ...newItems,
                                              ]);
        
                                              // Correctly update Formik values
                                              const currentItems =
                                                values.productRequests || [];
                                              setFieldValue("productRequests", [
                                                ...currentItems,
                                                ...newItems,
                                              ]);
        
                                              // Reset modal state
                                              setSearchProducts("");
                                              setSelectedProducts([]);
                                              setNextOffset(null);
                                              setOffset(0);
                                              setProductCount(0);
                                              handleCloseProductsView(false);
                                            }}
                                          >
                                            Add
                                          </Button>
                                        </Modal.Footer>
                                      </Modal>
                          
                                    </div>
                                  </div> */}
        <Row>
          <Col sm="12">
            <Card>
              <Card.Header className="d-flex justify-content-between listing-card-header">
                <div className="header-title">
                  <h4 className="card-title">Purchase Order List</h4>
                </div>
              </Card.Header>

              <div className="d-flex align-items-center justify-content-between">
                <Row className="align-items-center d-flex justify-content-between mt-2 w-100">
                  {/* Show entries section */}
                  <Col
                    sm="5"
                    md="4"
                    lg="4"
                    xs="12"
                    ref={alertRef}
                    className="order-1"
                  >
                    <div className="pt-4 d-flex align-items-center col-12 ms-4 listing-entries">
                      <label className="me-2">Show</label>
                      <select
                        className="form-select py-1 ps-2 pe-0 text-sm bg-white rounded-lg w-25"
                        value={entriesPerPage}
                        onChange={handleEntriesPerPageChange}
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span className="ms-2">entries</span>
                    </div>
                  </Col>

                  <Col sm="7" md="8" lg="8" xs="12" className="order-2">
                    <div className="pt-4 d-flex justify-content-start align-items-center">
                      <Row className="g-2 ms-4 ms-sm-0 align-items-end w-100 justify-content-end listing-controls-row">
                        {/* Search Input */}
                        <Col
                          xs="12"
                          sm="auto"
                          md="auto"
                          lg="auto"
                          className="d-flex ps-0 me-0 me-sm-0 flex-column flex-md-row align-items-start align-items-md-center listing-search-col"
                        >
                          <label className="me-2 mb-1 mb-md-0 text-nowrap">
                            Search:
                          </label>
                          <div
                            style={{ maxWidth: "180px", width: "100%" }}
                            className="listing-search-input-wrapper pe-sm-0 pe-3"
                          >
                            <SearchInput
                              searchQuery={searchQuery}
                              setSearchQuery={setSearchQuery}
                              loading={loading}
                              setLoading={setLoading}
                            />
                          </div>
                        </Col>

                        {orderHasCreatePermission &&
                          decodedToken?.roles?.every(
                            (role) => role.role_type !== roleTypes.SUPER_ADMIN,
                          ) && (
                            <Col
                              xs="12"
                              sm="auto"
                              md="auto"
                              lg="auto"
                              className="d-flex justify-content-start justify-content-md-end align-items-center ps-0 ps-sm-4 listing-add-button-col"
                            >
                              <Link
                                to={`/dashboard/app/purchase-order-add`}
                                className="mt-1 mt-md-0"
                              >
                                <Button
                                  type="submit"
                                  variant="btn btn-primary"
                                  className=" responsive-button "
                                >
                                  Create Order
                                </Button>
                              </Link>
                            </Col>
                          )}
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>

              <Card.Body className="px-0">
                {alert.alertFor === "orders" && (
                  <Row>
                    <Col className="mt-2 mb-2 ms-4 me-4">
                      <AlertNotificationSimple
                        type={alert.type}
                        message={alert.message}
                        show={alert.show}
                        onClose={() => setAlert({ ...alert, show: false })}
                      />
                    </Col>{" "}
                  </Row>
                )}

                 <div style={{ overflowX: "auto", width: "100%" }}>
                  <Table
                    id="category-list-table"
                    className=" table-user"
                    role="grid"
                    data-toggle="data-table"
                  >
                    <thead className="">
                      <tr style={{ backgroundColor: "#e2e4e9" }} className="tr-user">
                        <th
                          className="sticky-head-name th-user text-nowrap"
                          style={{width: "160px"}}
                        >
                          PO #
                        </th>
                        <th className="text-nowrap th-user">Vendor</th>
                        <th
                          className="text-nowrap th-user"
                          style={{ minWidth: "20rem" }}
                        >
                          Ship To
                        </th>
                        <th className="th-user">Order Status</th>
                        <th
                          className="text-nowrap th-user"
                          style={{ minWidth: "10rem" }}
                        >
                          Date
                        </th>
                        <th
                          className="text-nowrap th-user"
                          style={{ minWidth: "8rem" }}
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    {!dataLoader && orders.length > 0 ? (
                      <tbody>
                        {orders?.map((item, idx) => (
                          <tr
                            key={idx}
                            className="table-hover tr-user"
                            style={{
                              backgroundColor:
                                highlightedOrderId === item.id
                                  ? "#d0deefe6"
                                  : "transparent",
                              transition: "background-color 0.3s ease",
                            }}
                          >
                            <td className="text-nowrap sticky-data-names td-user"
                             style={{width: "160px"}}
                            >{item?.po_number}</td>
                            <td className="text-nowrap td-user">
                              {item?.vendor_name === "N/A" || !item?.vendor_name
                                ? "No vendor"
                                : item?.vendor_name}
                            </td>
                            <td style={{ maxWidth: "25rem" }} className="td-user">
                              <div
                                className="text-truncate"
                                title={item.ship_to || ""}
                              >
                                <EditableField
                                  id={item?.id}
                                  type="text"
                                  disabled={
                                    item.status === "Received in Full" ||
                                    item.status === "Cancelled" ||
                                    decodedToken?.roles.some(
                                      (role) =>
                                        role.role_type ===
                                        roleTypes.SUPER_ADMIN,
                                    ) ||
                                    !orderHasUpdatePermission
                                  }
                                  value={item.ship_to}
                                  field="shipTo"
                                  onSave={handleSaveField}
                                  isSuccess={
                                    successStatus.id === item.id &&
                                    successStatus
                                  }
                                  isFail={
                                    failStatus.id === item.id && failStatus
                                  }
                                  setFailStatus={setFailStatus}
                                />
                              </div>
                            </td>
                            <td className="td-user">
                              <div
                                className="text-truncate"
                                title={
                                  item.status
                                    ? optionsStatus.find(
                                        (option) =>
                                          option.value === item.status,
                                      )?.label
                                    : ""
                                }
                              >
                                <EditableFieldSelectStatus
                                  id={item?.id}
                                  value={item.status}
                                  disabled={
                                    item.status === "Received in Full" ||
                                    item.status === "Partially Received" ||
                                    item.status === "Cancelled" ||
                                    decodedToken?.roles.some(
                                      (role) =>
                                        role.role_type ===
                                        roleTypes.SUPER_ADMIN,
                                    ) ||
                                    !orderHasStatusPermission
                                  }
                                  field="status"
                                  onSave={handleSaveField}
                                  optionsStatus={optionsStatus}
                                  orderProducts={item.products || []}
                                  isSuccess={
                                    successStatus.id === item.id
                                      ? successStatus
                                      : null
                                  }
                                  isFail={
                                    failStatus.id === item.id
                                      ? failStatus
                                      : null
                                  }
                                  setFailStatus={setFailStatus}
                                  item={item}
                                />
                              </div>
                            </td>
                            <td className="text-nowrap td-user">
                              <EditableDateField
                                id={item?.id}
                                type="date"
                                disabled={
                                  true ||
                                  item.status === "Received in Full" ||
                                  decodedToken?.roles.some(
                                    (role) =>
                                      role.role_type === roleTypes.SUPER_ADMIN,
                                  ) ||
                                  !orderHasUpdatePermission
                                }
                                value={getLocalDate(item.date)}
                                field="date"
                                onSave={handleSaveField}
                                isSuccess={
                                  successStatus.id === item.id && successStatus
                                }
                                isFail={failStatus.id === item.id && failStatus}
                                setFailStatus={setFailStatus}
                              />
                            </td>
                            <td className="td-user">
                              <div className="d-flex align-items-center gap-2">
                                {(orderHasStatusPermission &&
                                  decodedToken?.roles.every(
                                  (role) =>
                                    role.role_type !== roleTypes.SUPER_ADMIN,
                                )) && (
                                  <Link
                                    className={`btn btn-sm btn-icon btn-primary ${
                                      item?.status !== "Received in Full" &&
                                      item?.status !== "Cancelled"
                                        ? "opacity-100"
                                        : "opacity-50 disabled"
                                    }`}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Mark as Received"
                                    data-original-title="Mark as Received"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (
                                        item?.status !== "Received in Full" &&
                                        item?.status !== "Cancelled"
                                      ) {
                                        handleReceiveAction(
                                          e,
                                          item,
                                          "Received in Full",
                                        );
                                      }
                                    }}
                                  >
                                    <span className="btn-inner">
                                      <BsInbox
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          color: "white",
                                        }}
                                      />
                                    </span>
                                  </Link>
                                )}
                                <Link
                                  className="btn btn-sm btn-icon btn-success"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    navigate(
                                      `/dashboard/app/purchase-order-view/${item.id}`,
                                    );
                                  }}
                                  title="View"
                                  data-original-title="View"
                                >
                                  <span className="btn-inner">
                                    <IoEyeOutline
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                      }}
                                    />
                                  </span>
                                </Link>
                                {decodedToken?.roles.every(
                                  (role) =>
                                    role.role_type !== roleTypes.SUPER_ADMIN,
                                ) && (
                                  <Link
                                    className={`btn btn-sm btn-icon btn-warning ${
                                      item?.status !== "Received in Full" &&
                                      item?.status !== "Cancelled" &&
                                      orderHasUpdatePermission
                                        ? "opacity-100"
                                        : "opacity-50 disabled"
                                    }`}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Edit"
                                    data-original-title="Edit"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (
                                        item?.status !== "Received in Full" &&
                                        item?.status !== "Cancelled" &&
                                        orderHasUpdatePermission
                                      ) {
                                        navigate(
                                          `/dashboard/app/purchase-order-edit/${item.id}`,
                                        );
                                      }
                                    }}
                                  >
                                    <span className="btn-inner">
                                      <svg
                                        width="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341"
                                          stroke="currentColor"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z"
                                          stroke="currentColor"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M15.1655 4.60254L19.7315 9.16854"
                                          stroke="currentColor"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </span>
                                  </Link>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : dataLoader ? (
                      <tbody>
                        <tr>
                          <td colSpan={6} className="text-center">
                            <FadeLoaderComponent />
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td colSpan={6}>
                            <div className="d-flex w-100 justify-content-center">
                              <p className="mb-0">No order found</p>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </Table>
                </div>

                <Row className="align-items-center mt-2">
                  <Col sm="6">
                    <div className="d-flex flex-wrap items-center ms-4">
                      <div className="">
                        Showing{" "}
                        {Math.min(
                          (currentPage - 1) * entriesPerPage + 1,
                          totalEntries,
                        )}{" "}
                        to{" "}
                        {Math.min(currentPage * entriesPerPage, totalEntries)}{" "}
                        of {totalEntries} entries
                      </div>
                    </div>
                  </Col>
                  <Col sm="6">
                    <div className="bd-example d-flex justify-content-center justify-content-md-end me-4">
                      <PaginationComponent
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default OrderRequestList;
